import React from 'react';
import AppLayout from '@/layouts/app-layout';
import PageTitle from '@/components/molecules/PageTitle';

/**
 * BFU50101G ダッシュボード
 */
class Container extends React.Component {
  render() {
    return (
      <AppLayout props={this.props}>
        <PageTitle pageTitle="ダッシュボード" />
      </AppLayout>
    );
  }
}
export default Container;
